import React, { useContext, useEffect, useState } from 'react'
import Input from '../../../components/Input/Input'
import Select from 'react-dropdown-select'
import Button from '../../../components/Button/Button'
import toast from 'react-hot-toast'
import SuperAdminContext from '../../../hooks/SuperAdminContext'
import Autocomplete from "react-google-autocomplete";
import { IoClose } from 'react-icons/io5';
import { handleGoogleApiLocation, handleInput } from 'Actions/commonAction/milleSearchFilterActions';
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'


const SuperAdminJobFilter = ({ setSortBy, setjobsSortBy, setEmployerOpen, employerJobType, employerJobSchedule, employerJobSector, employerJobSkill, employerJobSpeci, employerJobWorkplace, setEmployerJobSector, setEmployerJobSkill, setEmployerJobSpeci }) => {
    //Redux slice picker
    const selectmilleSearchStates = (state) => state.milleSearchStates;
    const selectMemoizedStates = createSelector(
        [selectmilleSearchStates],
        (milleSearchStates) => ({ milleSearchStates })
    );

    const { milleSearchStates } = useSelector(selectMemoizedStates);
    //

    const dispatch = useDispatch();

    const {
        setApplyFilterCount,
        jobApplyFilter,
        skillss, setSkillss,
        sectors, setSectors,
        specialization, setSpecialization,
        workplaceType, setWorkplaceType,
        jobTypee, setJobTypee,
        schedule, setSchedule,
        setjobApplyFilterObject,
        setCurrentPage, Jobplans,
        mellieSearchJobPlans, setMellieSearchJobPlans,
        setIsMilleSearchFiltered,
        jobStatusSelect, setJobStatusSelect,
        isSearched, superAdminJobSearch,
        handleAdminJobslMeilisearch
    } = useContext(SuperAdminContext);

    const jobStatusDropdown = [
        { value: 1, label: "All", send_data_to_api: "All" },
        { value: 2, label: "Open", send_data_to_api: "opened" },
        { value: 3, label: "Closed", send_data_to_api: "closed" },
        { value: 4, label: "Paused", send_data_to_api: "paused" },
    ]

    const [skillsSearch, setSkillsSearch] = useState(true);
    const [sectorSearch, setSectorSearch] = useState(true);
    const [speciSearch, setSpeciSearch] = useState(true);

    const handleWorkplaceType = (e) => {
        if (e.target.checked) {
            setWorkplaceType(prevState => [...prevState, e.target.name])
        }
        else {
            if (!e.target.checked) {
                const removeUnwantedWorkplace = workplaceType.filter((v) => {
                    return v !== e.target.name
                })
                setWorkplaceType(removeUnwantedWorkplace)
            }
        }
    }

    const handleJobType = (e) => {
        if (e.target.checked) {
            setJobTypee(prevState => [...prevState, e.target.name])
        }
        else {
            if (!e.target.checked) {
                const removeUnwantedJobType = jobTypee.filter((v) => {
                    return v !== e.target.name
                })
                setJobTypee(removeUnwantedJobType)
            }
        }
    }

    const handleSchedule = (e) => {
        if (e.target.checked) {
            setSchedule(prevState => [...prevState, e.target.name])
        }
        else {
            if (!e.target.checked) {
                const removeUnwantedSchedule = schedule.filter((v) => {
                    return v !== e.target.name
                })
                setSchedule(removeUnwantedSchedule)
            }
        }
    }

    useEffect(() => {
        var getFilterLength = skillss.length + sectors.length + milleSearchStates?.location.length + workplaceType.length + jobTypee.length + schedule.length + specialization.length + mellieSearchJobPlans.length + jobStatusSelect.length
        setApplyFilterCount(getFilterLength);
    }, [skillss, sectors, milleSearchStates?.location, specialization, workplaceType, jobTypee, schedule, jobStatusSelect])

    const handlePlans = (plansValue) => {
        setMellieSearchJobPlans(plansValue)
    }

    const initializeFilter = () => {
        setCurrentPage(0);
        setSortBy("Date Latest")
        setjobsSortBy("");

        var getFilterLength = skillss.length + sectors.length + milleSearchStates?.location.length + workplaceType.length + jobTypee.length + schedule.length + specialization.length + mellieSearchJobPlans.length + jobStatusSelect.length
        setApplyFilterCount(getFilterLength);

        if (getFilterLength > 0) {
            setIsMilleSearchFiltered(true)
            var a = skillss.map((v) => v.label)
            var b = sectors.map((v) => v.label)
            var c = specialization.map((v) => v.label)
            var e = mellieSearchJobPlans.map((v) => v.label)
            var jobStatus = jobStatusSelect.map((v) => v.send_data_to_api)

            const locationConvertion = milleSearchStates?.location.map((v) => {
                const originalVal = v.split(',')
                const joinOriginalValue = originalVal.join('&&&&&')

                return joinOriginalValue
            })

            let object;
            object = {
                skills: a,
                sector: b,
                specialisation: c,
                workplace_type: workplaceType,
                location: locationConvertion,
                job_type: jobTypee,
                work_schedule: schedule,
                plan: e[0] === "All" ? [] : e,
                job_status: jobStatus[0] === "All" ? [] : jobStatus,
                search_text: isSearched ? superAdminJobSearch : ''
            }

            setjobApplyFilterObject(object)
            handleAdminJobslMeilisearch(object)
        } else {
            toast.error('fields are empty');
        }
    }

    const handleJobStatus = (e) => {
        setJobStatusSelect(e)
    }

    const handleSkills = (skillsValue) => {
        setSkillss(skillsValue)

        if (skillsValue.length > 0) {
            const checkIfValueIsOthers = skillsValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = employerJobSkill.map((skills) => {
                    return skills.label !== "Others" ? { ...skills, disabled: true } : skills
                })
                setEmployerJobSkill(ChangeOtherValuesToDisable)
                setSkillsSearch(false)
            } else {
                const ChangeOtherValuesToDisable = employerJobSkill.map((skills) => {
                    return skills.label === "Others" ? { ...skills, disabled: true } : skills
                })
                setEmployerJobSkill(ChangeOtherValuesToDisable)
                setSkillsSearch(true)
            }
        } else {
            const ChangeDisableFalse = employerJobSkill.map((skills) => {
                return { ...skills, disabled: false }
            })
            setEmployerJobSkill(ChangeDisableFalse)
            setSkillsSearch(true)
        }
    }

    const handleSectors = (sectorValue) => {
        setSectors(sectorValue)
        if (sectorValue.length > 0) {
            const checkIfValueIsOthers = sectorValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = employerJobSector.map((sectors) => {
                    return sectors.label !== "Others" ? { ...sectors, disabled: true } : sectors
                })
                setEmployerJobSector(ChangeOtherValuesToDisable)
                setSectorSearch(false)
            } else {
                const ChangeOtherValuesToDisable = employerJobSector.map((sectors) => {
                    return sectors.label === "Others" ? { ...sectors, disabled: true } : sectors
                })
                setEmployerJobSector(ChangeOtherValuesToDisable)
                setSectorSearch(true)
            }
        } else {
            const ChangeDisableFalse = employerJobSector.map((sectors) => {
                return { ...sectors, disabled: false }
            })
            setEmployerJobSector(ChangeDisableFalse)
            setSectorSearch(true)
        }
    }

    const handleSpecilization = (specilizationValue) => {
        setSpecialization(specilizationValue)
        if (specilizationValue.length > 0) {
            const checkIfValueIsOthers = specilizationValue.filter((v) => {
                return v.label === "Others"
            })

            if (checkIfValueIsOthers.length > 0) {
                const ChangeOtherValuesToDisable = employerJobSpeci.map((specilization) => {
                    return specilization.label !== "Others" ? { ...specilization, disabled: true } : specilization
                })
                setEmployerJobSpeci(ChangeOtherValuesToDisable)
                setSpeciSearch(false)
            } else {
                const ChangeOtherValuesToDisable = employerJobSpeci.map((specilization) => {
                    return specilization.label === "Others" ? { ...specilization, disabled: true } : specilization
                })
                setEmployerJobSpeci(ChangeOtherValuesToDisable)
                setSpeciSearch(true)
            }
        } else {
            const ChangeDisableFalse = employerJobSpeci.map((specilization) => {
                return { ...specilization, disabled: false }
            })
            setEmployerJobSpeci(ChangeDisableFalse)
            setSpeciSearch(true)
        }
    }

    return (
        <div className="container">
            <form className='px-3 py-4'>

                <div className="mb-4">
                    <h5 className="job-filter-sub-headings">Schedule</h5>
                    {
                        employerJobSchedule.length > 0 ? <>
                            {employerJobSchedule.map((value, index) => {
                                return <div className="form-check ms-3" key={index}>
                                    <Input name={value} functionOnchange={handleSchedule} className={"form-check-input"} type={"checkbox"} testId={value} id={`workplace_${value}`} formFieldName={value} formLableFor={`workplace_${value}`} formLableclassName={"form-check-label"} />
                                </div>
                            })}
                        </>
                            :
                            null
                    }
                </div>

                <div className='mb-4'>
                    <h6 className='fw-bold'>Job status</h6>
                    <Select
                        color='#ffa32d'
                        style={{ fontSize: ".9rem" }}
                        className='rounded-1'
                        options={jobStatusDropdown}
                        onChange={handleJobStatus}
                        values={jobStatusSelect}
                    // searchable={skillsSearch}
                    />
                </div>

                <div className='mb-4'>
                    <h6 className='fw-bold'>Skills</h6>
                    <Select
                        multi
                        color='#ffa32d'
                        style={{ fontSize: ".9rem" }}
                        className='rounded-1'
                        options={skillss.length < 5 ? employerJobSkill : []}
                        addPlaceholder={skillsSearch ? "Only 5 Skills Can be selected" : ""}
                        onChange={handleSkills}
                        values={skillss}
                        searchable={skillsSearch}
                    />
                </div>


                <div className='mb-4'>
                    <h6 className='fw-bold'>Plan</h6>
                    <Select
                        color='#ffa32d'
                        style={{ fontSize: ".9rem" }}
                        className='rounded-1'
                        options={Jobplans}
                        onChange={handlePlans}
                        values={mellieSearchJobPlans}
                    />
                </div>


                <div className='mb-4'>
                    <h6 className='fw-bold'>Sector</h6>
                    <Select
                        multi
                        color='#ffa32d'
                        style={{ fontSize: ".9rem" }}
                        className='rounded-1'
                        options={sectors.length < 5 ? employerJobSector : []}
                        addPlaceholder={sectorSearch ? "Only 5 sectors Can be selected" : ""}
                        onChange={handleSectors}
                        values={sectors}
                        searchable={sectorSearch}
                    />
                </div>



                <div className='mb-4'>
                    <h6 className='fw-bold'>Functional Specialization</h6>
                    <Select
                        multi
                        color='#ffa32d'
                        style={{ fontSize: ".9rem" }}
                        className='rounded-1'
                        options={specialization.length < 5 ? employerJobSpeci : []}
                        addPlaceholder={speciSearch ? "Only 5 specialization Can be selected" : ""}
                        onChange={handleSpecilization}
                        values={specialization}
                        searchable={speciSearch}
                    />
                </div>



                <div className="mb-4">
                    <h5 className="job-filter-sub-headings">Workplace Type</h5>
                    {
                        employerJobWorkplace.length !== 0 ? <>
                            {employerJobWorkplace.map((value, index) => {
                                return <div className="form-check ms-3" key={index}>
                                    <Input name={value} functionOnchange={handleWorkplaceType} className="form-check-input" type="checkbox" testId={value} id={`workplace_${value}`} formFieldName={value} formLableFor={`workplace_${value}`} formLableclassName={"form-check-label"} />
                                </div>
                            })}
                        </>
                            :
                            null
                    }
                </div>


                <div className='mb-4'>
                    <h6 className='fw-bold'>Location</h6>
                    <div className={milleSearchStates?.location.length ? 'd-flex flex-wrap mb-2' : 'd-none'}>
                        {milleSearchStates?.location.map((v) => (
                            <div className="col-6 py-1 pe-1">
                                <div className="autocomplete-location-card w-100 d-flex flex-wrap align-items-center">
                                    <div className="col-10">
                                        <p className='w-100 mb-0 text-break'>{v}</p>
                                    </div>
                                    <div className="col-2">
                                        <IoClose className='fs-5 cursorPointer' onClick={() => dispatch(handleGoogleApiLocation({ type: "delete", deletionData: v }))} />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <Autocomplete
                        apiKey={process.env.REACT_APP_GOOGLE_PLACES_KEY}
                        className='google-places-api '
                        onPlaceSelected={(place) => {
                            if (place) {
                                dispatch(handleGoogleApiLocation({ type: "push", place: place.address_components }))
                            }
                        }}
                        onChange={(e) => dispatch(handleInput({ field: 'location', value: e.target.value }))}
                        value={milleSearchStates?.enteredInputLocation}
                        disabled={milleSearchStates?.location.length === 5}
                    />
                </div>


                <div className="mb-4">
                    <h5 className="job-filter-sub-headings">Job Type</h5>
                    {
                        employerJobType.length !== 0 ? <>
                            {employerJobType.map((value, index) => {
                                return <div className="form-check ms-3" key={index}>
                                    <Input name={value} functionOnchange={handleJobType} className={"form-check-input reset-jobType"} type={"checkbox"} testId={value} id={`workplace_${value}`} formFieldName={value} formLableFor={`workplace_${value}`} formLableclassName={"form-check-label"} />
                                </div>
                            })}
                        </>
                            :
                            null
                    }
                </div>

                <div>
                    <Button id="professionalHomeApplyFilterButton" buttonType={"button"} className={"btn btn-brand-color w-100"} title={"Apply Filter"} functionOnchange={() => {
                        initializeFilter()
                    }} />
                </div>
            </form>
        </div>
    )
}


export default SuperAdminJobFilter